import React, { Component } from 'react'
import { Table, Skeleton, Checkbox, message } from 'antd'
import InfiniteScroll from 'react-infinite-scroller'
import { Droppable, Draggable, DragDropContext } from 'react-beautiful-dnd'

// import { graphql, withApollo } from '@apollo/client/react/hoc'
// import MutationDeleteTagType from '../../../graphQL/admin/tagType/deleteTagType'
// import QueryTagType from './../../../graphQL/admin/tagType/listTagType'
// import QueryListAssetType from './../../../graphQL/admin/asset/listAssetTypes'
// import MutationBatchUpdateTagType from './../../../graphQL/admin/tagType/batchUpdateTagType'

// import FixedTableHeader from '../../../components/ui/dataDisplay/FixedTableHeader'
import AppContext from '../../../AppContext'
import ExpandMenuIcon from '../../../components/ui/general/icons/ExpandMenuIcon'
import PopoverButton from '../../../components/ui/general/buttons/PopoverButton'
import GroupDragAndDropIcon from '../general/icons/GroupDragAndDropIcon'
import AdminItemConfirmModal from '../../../components/ui/feedback/AdminItemConfirmModal'
import CreateAppModal from '../../../components/ui/dataEntry/other/CreateAppModal'
import { utilityService } from './../../../services/UtilityService'
import { generateCroppedThumbnail } from './../../../util/util'

import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { cloneDeep, flowRight as compose } from 'lodash'
import QueryListSettingApps from '../../../graphQL/appManager/listSettingApps'
import QueryCustomMetaFields from './../../../graphQL/admin/customMetaFields/listCustomMetaFields'
import MutationDeleteApp from './../../../graphQL/appManager/deleteApp'
import MutationBatchEditApp from './../../../graphQL/appManager/batchUpdateApp'

const deleteTagTypeMessage = {
  title: 'DELETE APP',
  firstMessage: 'Are you sure you want to delete this App?',
  secondMessage: 'This action cannot be undone.'
}

const options = [
  {
    type: 'edit',
    name: 'Edit'
  }
]

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  margin: '0',
  borderTop: isDragging ? '1px solid #cfd0d1' : 'none',
  borderLeft: isDragging ? '1px solid #cfd0d1' : 'none',
  borderRight: isDragging ? '1px solid #cfd0d1' : 'none',
  borderBottom: isDragging ? '1px solid #cfd0d1' : 'none',
  ...draggableStyle
})

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? 'white' : 'white'
})

class AppSettingList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      openedType: null,
      isLoading: !(props.appList && props.appList.length),
      isShowTagTypeModal: false,
      showDeleteTagTypeModal: false,
      selectedTagType: undefined,
      deleteLoading: false,
      isDeleteSuccess: false,
      isEdit: false,
      isDragStart: false,
      expandedRowKeys: [],
      tagTypeList: props.appList && props.appList.length ? props.appList : [],
      selectedIds: [],
      isPosChanging: false
    }
    this.columns = [
      {
        title: 'Title',
        dataIndex: 'name',
        key: 'name',
        width: '25%',
        render: (name, id) => this.renderTagTypeName(name, id),
        className: 'no-wrap'
      },
      {
        title: 'Bundle ID',
        dataIndex: 'bundleId',
        key: 'bundleId',
        width: '20%',
        render: (bundleId, id) => this.renderBundleId(bundleId, id),
        className: 'no-wrap'
      },
      {
        title: 'Icon',
        dataIndex: 'appIcon',
        key: 'appIcon',
        width: '10%',
        render: (name, id) => this.getLogoForApp(id),
        className: 'no-wrap'
      },
      {
        title: 'No of Pages',
        dataIndex: 'pageUsageCount',
        width: '10%',
        key: 'pageUsageCount',
        render: (tagCount) => this.renderTagTypeCount(tagCount),
        className: 'no-wrap'
      },
      {
        title: 'No of Configs',
        dataIndex: 'configUsageCount',
        width: '10%',
        key: 'configUsageCount',
        render: (tagCount) => this.renderTagTypeCount(tagCount),
        className: 'no-wrap'
      },
      {
        title: 'No of Widgets',
        dataIndex: 'widgetUsageCount',
        width: '10%',
        key: 'widgetUsageCount',
        render: (tagCount) => this.renderTagTypeCount(tagCount),
        className: 'no-wrap'
      },
      {
        key: 'id',
        dataIndex: 'id',
        width: '5%',
        render: (id) => this.renderData(id),
        className: 'no-wrap'
      }
    ]
  }

    componentDidMount = () => {
      document.addEventListener('mousedown', this.handleClickOutside)
    }

    UNSAFE_componentWillReceiveProps = newProps => { // eslint-disable-line camelcase
      if (!newProps.loading && !_.isEqual(newProps.appList, this.props.appList)) {
        const updatedAppList = (cloneDeep(newProps.appList) || []).map(item => {
          const index = (this.state.selectedIds || []).findIndex(selectedId => selectedId === item.id)
          if (index > -1) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }

          if (item.enabledAssetTypes === null) {
            item.enabledAssetTypes = []
          }

          return item
        })
        this.setState({ isSearching: false, isPaginating: false, isLoading: false, tagTypeList: _.cloneDeep(updatedAppList.sort((a, b) => (a.position - b.position))) })
      } else if (!newProps.loading && this.props.loading && this.state.isSearching && _.isEqual(newProps.appList, this.props.appList)) {
        this.setState({ isSearching: false, isLoading: false })
      } else if (newProps.loading && !_.isEmpty(newProps.appList) && !_.isEqual(newProps.appList, this.props.appList)) {
        const updatedAppList = (newProps.appList || []).map(item => {
          const index = (this.state.selectedIds || []).findIndex(selectedId => selectedId === item.id)
          if (index > -1) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }

          return item
        })
        this.setState({ isSearching: false, isPaginating: false, isLoading: false, tagTypeList: _.cloneDeep(updatedAppList.sort((a, b) => (a.position - b.position))) })
      } else if (newProps.loading && !_.isEmpty(newProps.appList) && _.isEqual(newProps.appList, this.props.appList)) {
        const updatedAppList = (newProps.appList || []).map(item => {
          const index = (this.state.selectedIds || []).findIndex(selectedId => selectedId === item.id)
          if (index > -1) {
            item.isSelected = true
          } else {
            item.isSelected = false
          }

          return item
        })
        this.setState({ isSearching: false, isPaginating: false, isLoading: false, tagTypeList: _.cloneDeep(updatedAppList.sort((a, b) => (a.position - b.position))) })
      }
    }

    componentWillUnmount () {
      document.removeEventListener('mousedown', this.handleClickOutside)
    }

    renderAssetTypeList=(title) => {
      return (
        <div className='assetType-list'>
          {this.getLogoForAsset(title)}
          {title}
        </div>
      )
    }

    getLogoForApp=(id) => {
      // debugger
      const { appList } = this.props
      const foundAsset = (appList || []).find(item => id.id === item.id)

      let src
      if (!_.isEmpty(foundAsset)) {
        src = (foundAsset.appIcon) ? <img src={generateCroppedThumbnail((foundAsset.appIcon ? foundAsset.appIcon : foundAsset.draftIcon), 23, 23, '2:2')} /> : <img src={null} />
      }
      return <div className='app-list-name'>
        {src}
      </div>
    }

    handleClickOutside = (event) => {
      const { target } = event
      const { className } = target
      const availableOptions = ['edit', 'transfer', 'delete']
      const isOptionClicked = availableOptions.findIndex(item => className === item)
      if (isOptionClicked > -1) {
        return
      }
      if (this.state.openedType) {
        this.setState({ openedType: null })
      }
    }

    showCreateTagTypeModal = (isShowTagTypeModal) => {
      this.setState({ isShowTagTypeModal, selectedTagType: null, isEdit: false })
    }

    toggleShowOptions = id => {
      if (this.state.openedType === id) {
        this.setState({ openedType: null })
      } else {
        this.setState({ openedType: id })
      }
    }

    onSelectOption = (id, selectedOption) => {
      const { appList, handleShowAppModal } = this.props
      const selectedTagType = appList.find(item => item.id === id)
      if (!selectedTagType) {
        return
      }
      if (selectedOption.type === 'edit') {
        this.setState({ selectedTagType, isEdit: true }, () => handleShowAppModal(true))
      } else if (selectedOption.type === 'delete') {
        this.setState({ showDeleteTagTypeModal: true, selectedTagType })
      }
      this.setState({ openedType: null })
    }

    loadMoreTagTypes = () => {
      if (this.props.totalCount === this.state.tagTypeList.length || this.state.isPaginating) { return }
      this.setState({ isPaginating: true }, () => this.props.getMoreTagTypes(this.state.tagTypeList.length))
    }

    hideDeleteAppModal = () => {
      this.setState({ isDeleteSuccess: true, selectedTagType: null }, () => {
        this.setState({ showDeleteTagTypeModal: false, isDeleteSuccess: false })
      })
    }

    renderTagTypeCount = (count) => {
      if (!count) {
        return <div className='app-count' >0</div>
      } else {
        return <div className='app-count'>{count}</div>
      }
    }

    renderTagTypeName=(name, props) => {
      return (
        <div className='tag-type-title'>
          <GroupDragAndDropIcon />
          {this.props.isDeleting ? (<Checkbox checked={this.checkIfSeleted(props.id)} onClick={() => this.onCheck(props.id)} />) : null}
          {name}
        </div>
      )
    }

    renderBundleId=(name, props) => {
      return (
        <div className='tag-type-id'>
          {this.props.isDeleting ? (<Checkbox checked={this.checkIfSeleted(props.id)} onClick={() => this.onCheck(props.id)} />) : null}
          {name}
        </div>
      )
    }

    checkIfSeleted=(id) => {
      let { tagTypeList } = this.state
      const index = tagTypeList.findIndex(tagType => tagType.id === id)
      if (index > -1) { return tagTypeList[index].isSelected } else { return false }
    }

    onCheck=(id) => {
      let { tagTypeList, selectedIds } = this.state
      const index = tagTypeList.findIndex(tagType => tagType.id === id)
      if (index > -1) {
        tagTypeList[index].isSelected = !tagTypeList[index].isSelected
        const selectedIndex = selectedIds.indexOf(id)
        if (selectedIndex > -1) {
          selectedIds.splice(selectedIndex, 1)
        } else {
          selectedIds.push(id)
        }
        this.setState({ selectedIds })
      }
    }

    onDragEnd = (result) => {
      const { appList, onHistoryUpdate } = this.props
      const startIndex = result && result.source && result.source.index
      const endIndex = result && result.destination && result.destination.index
      if (_.isEmpty(result) || _.isEmpty(result.destination)) {
        return
      }
      let { tagTypeList } = this.state
      const [ removed ] = tagTypeList.splice(startIndex, 1)
      removed.trackPosChange = true
      tagTypeList.splice(endIndex, 0, removed)
      tagTypeList = tagTypeList.map((item, index) => {
        item.position = index + 1
        return item
      })
      this.setState({ tagTypeList, isDragStart: false, isPosChanging: true })
      const changedTypes = tagTypeList.filter(tagType => {
        const selectedItem = appList.find(innerItem => innerItem.id === tagType.id)
        return selectedItem.position !== tagType.position
      })

      const variables = (changedTypes || []).map(item => {
        const newCustomMeta = ((item && item.customMeta) || []).map(innerItem => {
          const newItem = {
            config: '',
            value: ''
          }
          if (innerItem.config && innerItem.config.id) {
            newItem.config = innerItem.config.id
            newItem.value = innerItem.value
            newItem.name = innerItem.config.name || ''
          }
          return newItem
        })
        return {
          id: item.id,
          position: item.position,
          name: item.name,
          key: item.key,
          description: item.description,
          bundleId: item.bundleId,
          customMeta: newCustomMeta,
          appIcon: item.appIcon && item.appIcon.id,
          trackPosChange: item.trackPosChange,
          url: item.url || '',
          isCritical: item.isCritical
        }
      })
      this.props.batchUpdateApp({ input: variables }).then(() => {
        onHistoryUpdate()
        this.setState({ isPosChanging: false })
      }, error => {
        utilityService.handleError(error)
        this.setState({ isPosChanging: false })
      })
    }

    onDragStart = () => {
      const { expandedRowKeys } = this.state
      if (expandedRowKeys.length) { this.setState({ expandedRowKeys: [], isDragStart: true }) } else { this.setState({ isDragStart: true }) }
    }

     dragableBodyRow = (item) => {
       const { isDragStart, isPosChanging } = this.state
       const { index } = item
       return <Draggable key={item['data-row-key']} draggableId={item['data-row-key']} index={index} isDragDisabled={isPosChanging}>
         { (provided, snapshot) => {
           return <tr className={`ant-table-row${isDragStart ? ' dragEnable' : ''}`}
             ref={provided.innerRef}
             {...provided.draggableProps}
             {...provided.dragHandleProps}
             style={getItemStyle(
               snapshot.isDragging,
               provided.draggableProps.style
             )}
           >
             {item.children}
           </tr>
         }}</Draggable>
     }

     handleRowExpand = (record) => {
       this.setState(prevState =>
         prevState.expandedRowKeys.includes(record.id)
           ? {
             expandedRowKeys: prevState.expandedRowKeys.filter(
               key => key !== record.id
             )
           }
           : { expandedRowKeys: [...prevState.expandedRowKeys, record.id] }
       )
     }

     onDeleteAppModal = () => {
       const { selectedTagType } = this.state
       const { onHistoryUpdate } = this.props

       if (!selectedTagType) {
         return
       }
       this.setState({ deleteLoading: true })
       this.props.deleteApp(selectedTagType.id).then(() => {
         message.success('App deleted successfully')
         this.setState({ isDeleteSuccess: true, selectedTagType: null }, () => {
           this.setState({ showDeleteTagTypeModal: false, deleteLoading: false, isDeleteSuccess: false })
         })
         setTimeout(() => {
           this.setState({ isLoading: true }, () => this.props.refetchAppList())
         }, 800)

         onHistoryUpdate()
       }, error => {
         this.setState({ isDeleteSuccess: true, selectedTagType: null }, () => {
           this.setState({ showDeleteTagTypeModal: false, deleteLoading: false, isDeleteSuccess: false })
         })
         utilityService.handleError(error)
       })
     }

     handleAddTagType = () => {
       this.setState({ isShowTagTypeModal: false, selectedTagType: null })
     }

    renderData = (id) => {
      let availableOptions = []
      const { openedType } = this.state
      const { appList } = this.props
      const selectedTagType = appList.find(item => item.id === id)
      availableOptions = [ ...options ]
      if (selectedTagType && (!selectedTagType.configUsageCount && !selectedTagType.pageUsageCount && !selectedTagType.widgetUsageCount)) {
        const deleteOption = {
          type: 'delete',
          name: 'Delete'
        }
        availableOptions.push(deleteOption)
      }
      // if (this.isUpdateDisabled) {
      //   availableOptions.splice(1, 1)
      // }
      if (this.isCreateDisabled) {
        availableOptions.splice(0, 1)
      }
      if (availableOptions && availableOptions.length) {
        return (
          <div className='option-list' id='option-list'>
            <PopoverButton
              button={<div onClick={(e) => this.toggleShowOptions(id)} > <ExpandMenuIcon /> </div>}
              displayParam='name'
              contents={availableOptions}
              onContentClick={(selectedOption) => this.onSelectOption(id, selectedOption)}
              parentCompoent={'option-list'}
              isVisible={openedType === id}
              placement={'leftBottom'}
            />
          </div>
        )
      } else {
        return null
      }
    }

    renderRatingData = (data) => {
      let newData = (data || []).map(function (data) {
        return {
          title: data.assetType
        }
      })
      return <Table
        className={`inner-table inner-table-container`}
        rowKey={record => record.title}
        columns={this.metaDataColumns}
        dataSource={newData}
        pagination={false}
        showHeader
      />
    }

    renderInnerRows = (data) => {
      return <React.Fragment>
        {this.renderRatingData(data.enabledAssetTypes)}
      </React.Fragment>
    }

    onHandleBack=() => {
      let { parentRatingList } = this.state
      const newList = (parentRatingList || []).map(item => {
        item.isSelected = false
        return item
      })

      this.setState({ parentRatingList: newList })
      this.props.onHandleBackButton()
    }

    hideAppModal=() => {
      this.setState({ selectedTagType: null })
      this.props.hideAppModal()
    }

    refetchNewAppList=() => {
      this.setState({ isLoading: true }, () => this.props.refetchAppList())
    }

    render () {
      const { loading, listAssetTypes, onHistoryUpdate, showAppModal, appClient, appMetaFieldList, isAppAdminDisabled } = this.props
      const { isPaginating, selectedTagType, tagTypeList, showDeleteTagTypeModal, deleteLoading, isDeleteSuccess, isLoading } = this.state
      let adminItem
      if (selectedTagType && showDeleteTagTypeModal) {
        adminItem = <div >
          <p>{ selectedTagType.name }</p>
        </div>
      }

      const components = {
        body: {
          row: this.dragableBodyRow
        }
      }
      return (
        <AppContext.Consumer>
          {({ permissions, project }) => {
            const userPermissions = permissions['APP_MANAGER']
            // const isCreateDisabled = userPermissions.indexOf('CREATE') === -1
            // this.isDeleteDisabled = userPermissions.indexOf('DELETE') === -1
            // this.isUpdateDisabled = userPermissions.indexOf('UPDATE') === -1
            this.isCriticalDisabled = userPermissions.indexOf('CMS_WRITE_CRITICAL') === -1
            return <div className='admin-portal app-list-container'>
              <div className='admin-list'>
                {/* <FixedTableHeader columnCellList={this.columns} /> */}
                <InfiniteScroll
                  pageStart={0}
                  loadMore={this.loadMoreTagTypes}
                  hasMore={this.props.totalCount > tagTypeList.length}
                  initialLoad={false}
                  useWindow={false}
                >
                  <Skeleton active avatar={false} title paragraph={{ rows: 6 }} loading={isLoading || loading}>
                    <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart} >
                      <Droppable droppableId={'#TagType_123'}>
                        { (droppableProvided, droppableSnapshot) => (

                          <div className='tag-type-table-container'
                            ref={droppableProvided.innerRef}
                            style={getListStyle(droppableSnapshot.isDraggingOver)}
                          >
                            <Table
                              className={`general-table ${isPaginating ? 'paginating' : ''}`}
                              rowKey={record => record.id}
                              columns={this.columns}
                              dataSource={tagTypeList}
                              pagination={false}
                              // expandedRowRender={(data) => this.renderInnerRows(data)}
                              // expandedRowKeys={expandedRowKeys}
                              // onExpand={(expanded, record) => this.handleRowExpand(record)}
                              components={components}
                              onRow={(record, index) => ({
                                index,
                                moveRow: this.moveRow
                              })} />
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </Skeleton>
                  <Skeleton active avatar={false} title paragraph={{ rows: 1 }} loading={isPaginating} />
                </InfiniteScroll>
              </div>
              {/* <div className='admin-tag-type-footer' >
                <LoadingButton
                  type='primary'
                  onClick={() => this.showCreateTagTypeModal(true, true)}
                  htmlType='submit'
                  buttonText={'New'}
                  buttonClass='save-btn'
                  isLoading={false}
                  isDisabled={isCreateDisabled}
                />
              </div> */}
              <CreateAppModal
                isVisible={showAppModal}
                hideAppModal={this.hideAppModal}
                handleSubmit={this.handleAddTagType}
                details={selectedTagType}
                listAssetTypes={listAssetTypes}
                isFromEdit={!!selectedTagType && !showDeleteTagTypeModal}
                selectedApp={selectedTagType}
                isSubmitDisabled={false}
                isDeleteSuccess={isDeleteSuccess}
                maxPosition={tagTypeList && tagTypeList.length ? tagTypeList[tagTypeList.length - 1].position : 0}
                onHistoryUpdate={onHistoryUpdate}
                refetchNewAppList={this.refetchNewAppList}
                appMetaFieldList={appMetaFieldList}
                isCriticalDisabled={this.isCriticalDisabled}
                project={project}
                appClient={appClient}
                isAppAdminDisabled={isAppAdminDisabled}
              />
              <AdminItemConfirmModal
                isVisible={showDeleteTagTypeModal}
                title={deleteTagTypeMessage.title}
                firstMessage={deleteTagTypeMessage.firstMessage}
                secondMessage={deleteTagTypeMessage.secondMessage}
                adminItem={adminItem}
                rightButtonText={'Delete'}
                handleCancel={this.hideDeleteAppModal}
                handleSubmit={this.onDeleteAppModal}
                isSubmitButtonDisabled={false}
                isCancelButtonDisabled={false}
                isLoading={deleteLoading} />
            </div>
          }}
        </AppContext.Consumer>
      )
    }
}

AppSettingList.propTypes = {}

export default withApollo(
  compose(
    graphql(
      QueryListSettingApps,
      {
        options: ({ project, appClient }) => {
          return {
            variables: { limit: 499, project: project },
            fetchPolicy: 'network-only',
            client: appClient
          }
        },
        props: (props) => {
          const appList = props.data && props.data.listApps ? props.data.listApps.items : []
          return {
            appList,
            loading: props.data.loading || false,
            refetchAppList: () => {
              return props.data.refetch({ limit: 499,
                project: props.ownProps.project
              })
            }
          }
        }
      }
    ),
    graphql(
      QueryCustomMetaFields,
      {
        options: ({ project }) => {
          const variables = { section: 'APP', project: project }
          return {
            fetchPolicy: 'network-only',
            variables
          }
        },
        props: (props) => {
          const { data } = props
          let appMetaFieldList = data.listMetaFieldConfigs ? data.listMetaFieldConfigs : []
          appMetaFieldList = appMetaFieldList.map(item => {
            // if (item.isTransferring) {
            //   item.assetCount = 'Transferring'
            // }
            return item
          })
          return {
            appMetaFieldList
          }
        }
      }
    ),
    graphql(MutationDeleteApp, {
      options: ({ appClient, project }) => {
        return {
          update: (cache, { data: { deleteApp } }) => {
            let variables = { limit: 499, project: project }
            const cacheData = _.cloneDeep(cache.readQuery({ query: QueryListSettingApps, variables: variables }))
            if (cacheData && cacheData.listApps && cacheData.listApps.items) {
              let foundIndex = (cacheData.listApps.items).findIndex(item => item.id === deleteApp.id)
              if (foundIndex > -1) {
                // cacheData.listApps.items.splice(foundIndex, 1)
              }
            }
            cache.writeQuery({
              query: QueryListSettingApps,
              data: cacheData
            })
          },
          client: appClient
        }
      },
      props: props => ({
        deleteApp: (id) => {
          return props.mutate({
            variables: { id, project: props.ownProps.project }
          })
        }
      })
    }),
    graphql(
      MutationBatchEditApp,
      {
        options: ({ appClient }) => {
          return {
            client: appClient
          }
        },
        props: (props) => ({
          batchUpdateApp: (variables) => {
            variables.project = props.ownProps.project
            return props.mutate({
              variables,
              client: props.appClient
            })
          }
        })
      }
    )
  )(AppSettingList))
